
import { supabase } from '@/integrations/supabase/client';

/**
 * Check if the system-wide Telegram bot token is configured
 * This checks the Supabase secret rather than localStorage
 */
export const isSystemBotTokenConfigured = async (): Promise<boolean> => {
  try {
    const { data, error } = await supabase.functions.invoke('telegram-bot', {
      body: { action: 'test-connection' }
    });
    
    if (error) {
      console.error('Error checking bot token:', error);
      return false;
    }
    
    return data?.success === true;
  } catch (error) {
    console.error('Failed to check bot token:', error);
    return false;
  }
};

/**
 * Get bot information from the system
 */
export const getSystemBotInfo = async (): Promise<any | null> => {
  try {
    const { data, error } = await supabase.functions.invoke('telegram-bot', {
      body: { action: 'test-connection' }
    });
    
    if (error || !data?.success) {
      return null;
    }
    
    return data.bot_info || null;
  } catch (error) {
    console.error('Failed to get bot info:', error);
    return null;
  }
};
